import { Authority } from '../classes/enums/Authority';

/**
 * Authenticated user data class which is used for authentication related code.
 */
export class AuthUser {
  name: string;
  jwtToken: string;
  authorities: Authority[];

  /**
   * @param name a username
   * @param jwtToken a JWT token
   * @param authorities a list of authorized actions the user is allowed to execute.
   */
  constructor(name: string, jwtToken: string, authorities: Authority[]) {
    this.name = name;
    this.jwtToken = jwtToken;
    this.authorities = authorities;
  }
}
